// @flow
'use strict';

import * as React from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';

import Icone from '../../common/icone';
import Contador from '../../common/contador';
import CampoTexto from '../../common/campo_texto';
import ModalInformacoes from '../../common/modal_informacoes';
import ModalBuscaEstruturada from '../../nfce/formulario/modal_busca_estruturada';
import { Input } from '../../common/input';

type BuscaBasicaProps = {
  total : number,
  open : bool,
  handleSubmit : () => void,
  limpaFiltro : () => void,
  inicializaBuscaEstruturada : () => void,
  openInformacoes : bool,
  abreModalInformacoes : () => void,
};

export default function CamposBusca({ total, handleSubmit, limpaFiltro, inicializaBuscaEstruturada, openInformacoes, abreModalInformacoes } : BuscaBasicaProps) {
  return (
      <>
        <Form onSubmit={ handleSubmit }>
          <div className="form-group no-margin-bottom">
            <Row>
              <Col md={ 7 }>
                <div className="input-group">
                  <span className="input-group-addon">
                    <Button className="botao-informacoes no-padding" bsStyle="link" onClick={ abreModalInformacoes }>
                      <Icone nome="question-circle" estilo="fas" />
                    </Button>
                  </span>
                  <Input name="q" label="Livre" placeholder="Buscar" component={ CampoTexto }/>
                  <div className="input-group-btn">
                    <Button type="submit" bsStyle="primary">
                      <Icone nome="search" estilo="fas">Buscar</Icone>
                    </Button>
                  </div>
                </div>
              </Col>
              <Col md={ 5 }>
                <Button type="reset" onClick={ limpaFiltro }>
                  <Icone nome="eraser" estilo="fas">Limpar</Icone>
                </Button>{ ' ' }
                <Button type="reset" bsStyle="primary" onClick={ inicializaBuscaEstruturada }>Busca Avançada</Button>
              </Col>
            </Row>
          </div>
          <Contador total={ total } prefix="Documentos encontrados:"/>
        </Form>

        { open && <ModalBuscaEstruturada/> }

        { openInformacoes && <ModalInformacoes/> }
      </>
  );
}
